import { render, staticRenderFns } from "./RegisterFail.vue?vue&type=template&id=3a035e76&scoped=true"
import script from "./RegisterFail.vue?vue&type=script&lang=js"
export * from "./RegisterFail.vue?vue&type=script&lang=js"
import style0 from "./RegisterFail.vue?vue&type=style&index=0&id=3a035e76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a035e76",
  null
  
)

export default component.exports